export default {
  OpenPopupInSeconds: 7000,
  ConfiguredPaths: ['/*'],
  publishableKey: 'pk_live_PBq9KCfrqvX6Iew9qG4Duyh800WrfY5Vbp',
  //publishableKey: 'pk_test_Ag15o71ubZEXJVQ7QA8NnUjD00oUdxMKct',
  // prodkey pk_live_PBq9KCfrqvX6Iew9qG4Duyh800WrfY5Vbp
  // testkey pk_test_Ag15o71ubZEXJVQ7QA8NnUjD00oUdxMKct
  // pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3
};
